enum DocumentCategoryFieldNames {
  Id = 'id',
  Color = 'color',
  Name = 'name',
  Description = 'description',
  DocumentPermissionsTitle = 'documentPermissionsTitle',
  AllowDownload = 'allowDownload',
  AllowPrint = 'allowPrint',
}

export default DocumentCategoryFieldNames;
